import axios from 'axios';

const http = axios.create({
    baseURL: process.env.API_URL || ''
});

if(!process.env.API_URL) {
    console.log('No API URL given');
}

http.interceptors.request.use(function(config) {
    config.withCredentials = true;
    return config;
});

http.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    return Promise.reject(error);
});

export { http };

export default http;